import { useState } from 'react';
import { apiFetch } from '../config/api';

export default function SendOnboardingWhatsAppButton({ token, parentId, schoolId, hasPassword = false }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (hasPassword && !window.confirm('This user is already on board. Send the onboarding WhatsApp anyway?')) {
      return;
    }

    setSending(true);
    setSent(false);
    setError('');

    try {
      await apiFetch('/whatsapp/send-onboarding', {
        method: 'POST',
        body: JSON.stringify({ contact_id: parentId, school_id: schoolId }),
      }, token);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <button
        className="sa-btn sa-btn-secondary"
        style={{ padding: '4px 10px', fontSize: 12 }}
        onClick={handleSend}
        disabled={sending || sent}
      >
        {sending ? 'Sending...' : sent ? 'WhatsApp Sent' : 'Send Onboarding WhatsApp'}
      </button>
      {error ? <span style={{ color: '#991b1b', fontSize: 12 }}>{error}</span> : null}
    </div>
  );
}
